import Vue from 'vue'
import API from '../utils/api'
import env from '../../../config/prod.env.js'

const state = {
  kpis: [],
  kpis: null,
  sortAd: [],
  currentPage: null
}

const mutations = {  
  SET_KPIS (state, payload) {
    state.kpis = payload
  },
  SET_KPI (state, payload) {
    state.kpi = payload
  },
  SET_SORT_AD (state, payload) {
    state.sortAd = payload
  },
  SET_CURRENT_PAGE (state, payload) {
    state.currentPage = payload
  },
  API_FAILURE (state, payload) {
    throw {error: true, payload: payload.body}
  } 
}

const actions = {
  kpiList: (context, data) => {
    let query = '?'        
    if (data.pagination) {
      query += `page=${data.pagination.page}&records=${data.pagination.perPage}`      
    } else {          
      query = ''
    }
    if (data.sort) {
      query += `&sortBy=${data.sort.sortBy}&sortDesc=${data.sort.sortDesc}`      
    }
    if (data.search) {
      query += `&search=${data.search}`      
    }

    return Vue.http.post(`${env.API}/api/kpi/list`, data)    
      .then((response) => {        
        context.commit('SET_KPIS', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  kpiSelectList: (context, data) => {
    return Vue.http.get(`${env.API}/api/kpi/select-list`)    
      .then((response) => {        
        context.commit('SET_PRODUCTS', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  kpiByIds: (context, data) => {
    let query = '?'
    if (Array.isArray(data.ids)) {
      for (let element of data.ids) {                 
        query += `&ids[]=${element._id}`
      }
    }
    if (Array.isArray(data.role)) {
      for (let r of data.role) {
        query += `&role[]=${r._id}`
      }
    }
    return Vue.http.get(`${env.API}/api/kpi/by-ids${query}`)    
      .then((response) => {        
        context.commit('SET_KPIS', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  getKpiById: (context, id) => {
    return Vue.http.get(`${env.API}/api/kpi/by-id/${id}`)    
      .then((response) => {
        context.commit('SET_KPI', response.body.message)            
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  updateKpi: (context, data) => {
    return Vue.http.put(`${env.API}/api/kpi/${data.id}`, data)    
      .then((response) => {                
        return response.body
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  createKpi: (context, data) => {
    return Vue.http.post(`${env.API}/api/kpi`, data)
    .then((response) => {
      return response.body.message
    })
    .catch((error) => {
      return context.commit('API_FAILURE', error)
    })
  },
  deleteKpi: (context, data) => {
    return Vue.http.delete(`${env.API}/api/kpi/${data.id}`, data)
    .then((response) => {
      return response.body.message
    })
    .catch((error) => {
      return context.commit('API_FAILURE', error)
    })
  },
  updateSortAd: (context, data) => {
    return context.commit('SET_SORT_AD', data)
  },
  kpiBySegTraProRole: (context, data) => {
    return Vue.http.post(`${env.API}/api/kpi/by-seg-trav-prod-role`, data)    
      .then((response) => {
        context.commit('SET_KPIS', response.body.message)            
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  updateCurrentPage: (context, page) => {
    return context.commit('SET_CURRENT_PAGE', page)
  }
}

const getters = {
  getKpis: (state) => state.kpis,
  getKpi: (state) => state.kpi,
  getSortAd: (state) => state.sortAd,
  getCurrentPage: (state) => state.currentPage
}

export const kpi = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/kpi.js